'use client';

import { useCallback } from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal } from '@components/common/Modal/Modal';
import GeminiVoiceWidget from '@components/features/voice/GeminiVoiceWidget';
import type { GeminiVoiceOptions } from '@hooks/voice/useGeminiVoice';

export const GeminiVoiceModal = NiceModal.create<GeminiVoiceOptions & { onClosed?: () => void }>((props) => {
  const modal = useModal();
  const { onClosed, ...widgetProps } = props;

  const closeModal = useCallback(() => {
    onClosed?.();
    void modal.hide();
    modal.remove();
  }, [modal, onClosed]);

  return (
    <Modal
      isOpen={modal.visible}
      onClose={closeModal}
      backdropClickDisabled
      size="sm"
      className="!max-w-sm !rounded-3xl"
      body={<GeminiVoiceWidget {...widgetProps} onClose={closeModal} />}
    />
  );
});
